import { gql } from '@apollo/client';

const PORTFOLIO_OPTIONS = gql`
  query portfolioOptions($countryName: String!, $client: Boolean!) {
    getPortfolioTypeEnum(countryName: $countryName, client: $client) {
      value
      label
    }
    getPortfolioFormatEnum {
      value
      label
    }
  }
`;

export default PORTFOLIO_OPTIONS;
